import React from 'react';
import {NextSeo} from 'next-seo';
import JobDetail from '@components/JobDetails/JobDetail';
import JobDetailNav from '@components/JobDetails/JobDetailNav';
import { BookingProvider } from '@contexts/BookingContext';

export default function JobDetailPage(props) {
    const {seoPage, recruitment, relatedRecruitments} = props;
    
    return (
        <BookingProvider>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
                <JobDetailNav recruitment={recruitment} />
                <JobDetail 
                    preloadedRecruitment={recruitment}
                    preloadedRelated={relatedRecruitments}
                />
            </div>
        </BookingProvider>
    );
}

JobDetailPage.PageName = 'JOB';
